import { render, staticRenderFns } from "./EmailSettingsAccountModeTransfer.vue?vue&type=template&id=28c30616&scoped=true&"
import script from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsAccountModeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettingsAccountModeTransfer.vue?vue&type=style&index=0&id=28c30616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c30616",
  null
  
)

export default component.exports